import z from 'zod';

/**
 * Schema for the session id cache
 */
export const sessionIdCacheSchema = z.object({
  sessionId: z.string(),
  sessionIdError: z.string(),
});

export interface SessionIdCache extends z.infer<typeof sessionIdCacheSchema> {}
